import { Keyword } from "@siteimprove/alfa-css";
import { None, Option } from "@siteimprove/alfa-option";
import { Media } from "./media.js";
/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#scripting}
 *
 * @public
 */
export class Scripting extends Media {
    static of(value) {
        return new Scripting(Option.of(value));
    }
    static _boolean = new Scripting(None);
    constructor(value) {
        super("scripting", value);
    }
    static boolean() {
        return Scripting._boolean;
    }
    matches(device) {
        return device.scripting.enabled
            ? this._value.every((value) => value.matches(Keyword.of("enabled")))
            : this._value.some((value) => value.matches(Keyword.of("none")));
    }
}
/**
 * @public
 */
(function (Scripting) {
    function from(value) {
        return value.map(Scripting.of).getOrElse(Scripting.boolean);
    }
    Scripting.parse = Media.parseDiscrete("scripting", from, "none", "initial-only", "enabled");
})(Scripting || (Scripting = {}));
//# sourceMappingURL=scripting.js.map